import { withLoader } from 'util/routeHelper';

export default store => ({
	path: '*',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'404',
				),
			store,
			'PAGE404',
		),
	},
});



// WEBPACK FOOTER //
// ./src/routes/Page404/index.js